import React from "react";
import { Container, Row, Col } from "react-bootstrap";

const Services = () => {
  return (
    <section
      id="services"
      style={{
        backgroundColor: "#f7f7f7",
        overflow: "hidden",
        minHeight: "100vh",
      }}
      className="d-flex justify-content-start align-items-center flex-column"
    >
      <div
        style={{
          backgroundColor: "rgb(15, 12, 31)",
          padding: "20px",
          width: "100%",
          color: "#fff",
          marginBottom: "5rem",
        }}
      >
        <h3 className="mb-2 text-center">Services</h3>
        <p className="text-center">
          Years of dedicated learning coupled with my degree in Electrical and
          Information Engineering enable me to offer the following.
        </p>
      </div>
      <Container>
        <Row>
          <Col lg={3} md={6} className="d-flex align-items-stretch">
            <div
              className="core-value"
              style={{ margin: "auto", marginBottom: "4rem" }}
            >
              <div
                style={{
                  borderRadius: "100%",
                  padding: "6px",
                  paddingLeft: "9px",
                  paddingRight: "9px",
                  color: "#6936F4",
                  backgroundColor: "#fff",
                  border: "1px solid #6936F4",
                }}
                className="btn btn-light btn-social"
              >
                <i className="fa-regular fa-laptop"></i>
              </div>
              <h3 className="mt-2">Web Development</h3>
              <p className="mb-4 text-justify">
                I offer professional web development services, creating
                responsive and user-friendly websites tailored to your specific
                requirements.
              </p>
              <div
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "25px",
                  border: "1px solid #6936F4",
                  color: "#6936F4",
                  width: "50%",
                  padding: "2px",
                  fontSize: "small",
                  marginTop: "auto",
                }}
                className="text-center"
              >
                Hire Me
              </div>
            </div>
          </Col>

          <Col lg={3} md={6} className="d-flex align-items-stretch">
            <div
              className="core-value"
              style={{ margin: "auto", marginBottom: "4rem" }}
            >
              <div
                style={{
                  borderRadius: "100%",
                  padding: "6px",
                  paddingLeft: "9px",
                  paddingRight: "9px",
                  color: "#6936F4",
                  backgroundColor: "#fff",
                  border: "1px solid #6936F4",
                }}
                className="btn btn-light btn-social"
              >
                <i class="devicon-android-plain"></i>
              </div>
              <h3 className="mt-2">Mobile Development</h3>
              <p className="mb-4 text-justify">
                I specialize in mobile app development, creating intuitive and
                engaging applications for iOS and Android platforms.
              </p>
              <div
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "25px",
                  border: "1px solid #6936F4",
                  color: "#6936F4",
                  width: "50%",
                  padding: "2px",
                  fontSize: "small",
                }}
                className="text-center"
              >
                Hire Me
              </div>
            </div>
          </Col>

          <Col lg={3} md={6} className="d-flex align-items-stretch">
            <div
              className="core-value"
              style={{ margin: "auto", marginBottom: "4rem" }}
            >
              <div
                style={{
                  borderRadius: "100%",
                  padding: "6px",
                  paddingLeft: "9px",
                  paddingRight: "9px",
                  color: "#6936F4",
                  backgroundColor: "#fff",
                  border: "1px solid #6936F4",
                }}
                className="btn btn-light btn-social"
              >
                <i className="fa-regular fa-cogs"></i>
              </div>
              <h3 className="mt-2">Machine Learning and Data Science</h3>
              <p className="mb-4 text-justify">
                I have expertise in machine learning and data science,
                leveraging algorithms and techniques to extract insights and
                make data-driven decisions.
              </p>
              <div
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "25px",
                  border: "1px solid #6936F4",
                  color: "#6936F4",
                  width: "50%",
                  padding: "2px",
                  fontSize: "small",
                }}
                className="text-center"
              >
                Hire Me
              </div>
            </div>
          </Col>

          <Col lg={3} md={6} className="d-flex align-items-stretch">
            <div
              className="core-value"
              style={{ margin: "auto", marginBottom: "4rem" }}
            >
              <div
                style={{
                  borderRadius: "100%",
                  padding: "6px",
                  paddingLeft: "9px",
                  paddingRight: "9px",
                  color: "#6936F4",
                  backgroundColor: "#fff",
                  border: "1px solid #6936F4",
                }}
                className="btn btn-light btn-social"
              >
                <i className="fa-regular fa-microchip"></i>
              </div>
              <h3 className="mt-2">Hardware Programming</h3>
              <p className="mb-4 text-justify">
                I specialize in hardware programming, developing software and
                firmware solutions for embedded systems and IoT devices.
              </p>
              <div
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "25px",
                  border: "1px solid #6936F4",
                  color: "#6936F4",
                  width: "50%",
                  padding: "2px",
                  fontSize: "small",
                }}
                className="text-center"
              >
                Hire Me
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default Services;
